import React, { useState, useEffect } from 'react'
import Title from '../../Title'
import Select from 'react-select'
import NumberHorizontalLayout from '../../layouts/NumberHorizontalLayout'
import classnames from 'classnames'


export default function DischargeSurvey(props) {
  let metrics = [
    {
      title: 'Would recommend the program to a friend or loved One',
      format: 'number_horizontal',
      endpoint: 'would_recommend_percentage',
      visible: true,
    },
    {
      title: 'Overall Staff Rating',
      format: 'number_horizontal',
      endpoint: 'overall_staff_rating',
      visible: true,
    },
    {
      title: 'Overall Experience',
      format: 'number_horizontal',
      endpoint: 'overall_experience',
      visible: true,
    },
    {
      title: 'Recovery Activities',
      format: 'number_horizontal',
      endpoint: 'recovery_activities',
      visible: true,
    },
    {
      title: 'Counseling Sessions',
      format: 'number_horizontal',
      endpoint: 'counseling_sessions',
      visible: true,
    },
    {
      title: 'Content of Group in Relevance to Needs',
      format: 'number_horizontal',
      endpoint: 'content_of_group_in_relevance_to_needs',
      visible: true,
    },
    {
      title: 'Knowledge and Professionalism of Counselors',
      format: 'number_horizontal',
      endpoint: 'knowledge_and_prefessionalism_of_counselors',
      visible: true,
    },
    {
      title: 'Responsiveness of Staff to Treatment Needs',
      format: 'number_horizontal',
      endpoint: 'responsiveness_of_staff_to_treatment_needs',
      visible: true,
    },
    {
      title: 'Staff Courteousness',
      format: 'number_horizontal',
      endpoint: 'staff_courteousness',
      visible: true,
    },
    {
      title: 'Living Environment',
      format: 'number_horizontal',
      endpoint: 'living_environment',
      visible: true,
    },
    {
      title: 'Facility Condition',
      format: 'number_horizontal',
      endpoint: 'facility_condition',
      visible: true,
    },
    {
      title: 'Welcome and Orientation',
      format: 'number_horizontal',
      endpoint: 'welcome_and_orientation',
      visible: true,
    },
    {
      title: 'Admission Representative',
      format: 'number_horizontal',
      endpoint: 'admission_representative',
      visible: true,
    },
  ]

  return(
    <div>
      <div className="ml-4">
        <div className="col-12 mt-4 bg-white p-0 shadow">
          <div className="bg-info p-3">
            <div className="col-12 text-align-left title">Discharge Survey</div>
          </div>
          <div className="col-12 d-flex flex-wrap p-4 ml-2">
            {
            metrics.filter( metric => metric.visible == true ).map( (metric, index) => {
              return <div className={classnames("pt-3", "col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} >
                <div className='bg-reg shadow mt-2'>
                  <NumberHorizontalLayout {...props} metric={metric} index={index} /> 
                </div>
              </div>
            })
            }
          </div>
        </div>
      </div>

    </div>
  )
}
